import React from 'react';

import Hero from '../components/public/Hero';
import BookingForm from '../components/public/BookingForm';
import ContactForm from '../components/public/ContactForm';
import TopBar from '../components/public/TopBar';
import LandingFooter from '../components/public/LandingFooter';

import './Landing.css';

export default function Landing() {
  return (
    <div className="landing">
      <TopBar />

      <section id="top" className="landing-section">
        <Hero />
      </section>

      <section id="book" className="landing-section">
        <BookingForm />
      </section>

      <section id="contact" className="landing-section">
        <ContactForm />
      </section>

      <LandingFooter />
    </div>
  );
}